module.exports = __webpack_public_path__ + "img/venus25.7d8e5d28.png";